(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('OfficePhoneSearch', OfficePhoneSearch);

    OfficePhoneSearch.$inject = ['$resource'];

    function OfficePhoneSearch($resource) {
        var resourceUrl =  'api/_search/office-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
